import { NO_ACTION } from '@core/state/action-types';
import { Action } from '@ngrx/store';

export class NoAction implements Action {
    readonly type: string = NO_ACTION;
  
      /**
       * Pass optional context/string to NoAction to easily identify in the Store Devtools where is it dispatched from
       * Currently there are too many NO_ACTIONs in dev tools with no way to track
       * @param payload
       */
      constructor(public payload?: {
          from?: string // define from which effect (action name) was it dispatched
          context?: any // any additional information if necessary
      }) {}
}
